import React from 'react';
import SvgIcon from './SvgIcon';

const ArrowRightUp = props => (
    <SvgIcon viewBox="0 0 24 24" fill="none" {...props}>
        <path
            d="M16.5 7.5l-9.75 9.75M16.5 15V7.5H9"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

ArrowRightUp.displayName = 'ArrowRightUpIcon';

export default ArrowRightUp;
